export function buildNavigationTree(
	items: NavigationItem[]
): NavigationTreeNode[] {
	const nodeMap = new Map<string, NavigationTreeNode>();

	for (const item of items) {
		nodeMap.set(item.id, { item, children: [] });
	}

	const roots: NavigationTreeNode[] = [];

	for (const item of items) {
		const node = nodeMap.get(item.id)!;

		if (
			item.parent !== null &&
			item.parent !== item.id &&
			nodeMap.has(item.parent)
		) {
			nodeMap.get(item.parent)!.children.push(node);
		} else {
			roots.push(node);
		}
	}

	const sortNodes = (nodes: NavigationTreeNode[]): NavigationTreeNode[] => {
		const safeOrder = (n: NavigationTreeNode) =>
			Number.isFinite(n.item.ordering) ? n.item.ordering : Infinity;
		nodes.sort((a, b) => safeOrder(a) - safeOrder(b));
		for (const node of nodes) {
			sortNodes(node.children);
		}
		return nodes;
	};

	return sortNodes(roots);
}
